import { IPrismicImage, IPrismicLink } from './prismic';

export enum WidgetSliceNameEnum {
  GRID_LINKS_WIDGET = 'grid_links_widget',
  ROW_LINKS_WIDGET = 'row_links_widget',
  SINGLE_LINK_WIDGET = 'single_link_widget',
  REORDER_WIDGET = 'reorder_widget',
}

export interface IReorderWidget {
  primary: {
    title: string;
    buttonLabel: string;
  };
  slice_type: WidgetSliceNameEnum.REORDER_WIDGET;
}

export interface ISingleLinkWidget {
  primary: {
    title: string;
    image: IPrismicImage;
    link: IPrismicLink;
    isButtonLink: boolean;
    linkLabel: string;
    trackingId?: string;
  };
  slice_type: WidgetSliceNameEnum.SINGLE_LINK_WIDGET;
}

export interface IRowLinksWidget {
  primary: {
    title: string;
  };
  items: Array<{
    picto: IPrismicImage;
    label: string;
    link: IPrismicLink;
  }>;
  slice_type: WidgetSliceNameEnum.ROW_LINKS_WIDGET;
}

export interface IGridLinksWidget {
  primary: {
    title: string;
  };
  items: Array<{
    image: IPrismicImage;
    label: string;
    link: IPrismicLink;
    trackingId?: string;
  }>;
  slice_type: WidgetSliceNameEnum.GRID_LINKS_WIDGET;
}

export type WidgetsType = Array<
  IReorderWidget | ISingleLinkWidget | IRowLinksWidget | IGridLinksWidget
>;
